import { render, staticRenderFns } from "./CategoryNavigation.vue?vue&type=template&id=32c4f5e0&"
import script from "./CategoryNavigation.ts?vue&type=script&lang=ts&"
export * from "./CategoryNavigation.ts?vue&type=script&lang=ts&"
import style0 from "./CategoryNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports